export default __webpack_public_path__ + "static/media/meeting_window.52309efc.svg";